import { MemberAccessReason } from "./member-access-reason.model";
import { MemberAccessActionType } from "./enums";

export class MemberAccess {
    public id: number;
    public memberAccessReasonId: number;
    public memberAccessReason: MemberAccessReason;
    public aspNetUserId: string;
    public startTime: Date;
    public endTime: Date;
    public note: string;
    public isResolved: boolean;
    public memberAccessActionType: MemberAccessActionType;
    public  memberId: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/member-access.model.ts